<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll">
            <ReviewNav :activeIndex="2"></ReviewNav>

            <div class="white-box strategy">
                <div class="mGuide-header active">
                    <div class="mGuide-header-txt">船上攻略</div>
                </div>
                <a class="external strategy-row" target="_blank" v-for="item in guideList" :key="item.id" :href="item.url">
                    <div class="strategy-row-arrow"></div>
                    <div class="strategy-row-inner">
                        <div class="inner1">
                            <span class="bold">{{item.title}}：</span><div class="description" v-html="item.description"></div>
                        </div>
                        <div class="inner2">
                            <span class="bold">{{item.title}}：</span>{{item.description}}
                        </div>
                    </div>
                    <div class="strategy-row-media"><img src="../../assets/downloadY.png" alt=""></div>
                </a>
            </div>

            <!-- 爆款推荐 -->
            <div class="shipDetail-hotCruise scroll-container">
                <PromoCruise></PromoCruise>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import ReviewNav from '@/components/Review/ReviewNav.vue'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    export default {
        name: 'Guide',
        components: {
            ReviewNav,
            PromoCruise
        },
        data () {
            return {
                userToken: '',
                guideList: []
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '游记攻略')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
                this.guideList = await this.getGuide()
            },
            async getGuide () {
                const {success, data, errMsg} = await api.review.getGuide()
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .page-content{
        padding-top: 50px;
    }

    .white-box{
        margin-bottom: 10px;
        background-color: #fff;
        border-bottom: 1px solid #e2e2e2;
    }

    .mGuide-header {
        display:flex;
        align-items:center;
        justify-content:space-between;
        width:350px;
        height:40px;
        margin-left:auto;
        margin-right:auto;
        padding-left:15px;
        padding-right:15px;
    }
    .mGuide-header-txt {
        font-size: 13px;
        color: #061556;
        line-height:17px;
        font-weight:bold;
    }
    .mGuide-header-arrow {
        width: 8px;
        height: 8px;
        -webkit-transform: rotateZ(-45deg);
        transform: rotateZ(-45deg);
        border-right: 1px solid #fab911;
        border-bottom: 1px solid #fab911;
    }
    .mGuide-header.active .mGuide-header-arrow {
        -webkit-transform: rotateZ(45deg);
        transform: rotateZ(45deg);
    }

    .travelGuide {
        border-top: 1px solid #dddddd;
    }

    .strategy {
        padding-bottom:20px;
        border-top: 1px solid #dddddd;
    }
    .strategy .mGuide-header {
        border-bottom: 1px solid #dddddd;
    }
    .strategy-row {
        display: flex;
        width: 350px;
        margin-left: auto;
        margin-right: auto;
        padding: 10px 10px 10px 5px;
        border-bottom: 1px solid #dddddd;
    }
    .strategy-row-arrow {
        flex:none;
        position: relative;
        width:21px;
        height: 21px;
        background-color: #fab911;
        border-radius:50%;
        opacity:0;
    }
    .strategy-row-arrow::after {
        content: '';
        position: absolute;
        left: 4px;
        top: 6px;
        display: block;
        width: 8px;
        height: 8px;
        -webkit-transform: rotateZ(-45deg);
        transform: rotateZ(-45deg);
        border-right: 1px solid #fff;
        border-bottom: 1px solid #fff;
    }
    .strategy-row.active .strategy-row-arrow::after {
        left: 6px;
        top: 5px;
        -webkit-transform: rotateZ(45deg);
        transform: rotateZ(45deg);
    }
    .strategy-row-media {
        flex: none;
        display: block;
        width: 21px;
        height:22px;
    }
    .strategy-row-media img {
        max-width:100%;
    }
    .strategy-row-inner {
        position:relative;
        flex:1;
        width:293px;
        padding-top:3px;
        padding-left:6px;
        padding-right:8px;
        font-size:11px;
        color:#333;
        line-height:17px;
    }
    .strategy-row-inner p {
        display:inline-block;
        margin:0;
    }
    .strategy-row-inner .inner1 {
        width:100%;
        height: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .strategy-row-inner .inner2 {
        display:none;
    }
    .strategy-row.active .inner1 {
        display:none;
    }
    .strategy-row.active .inner2 {
        display: block;
    }
    .strategy-row-inner .bold {
        display: inline-block;
        vertical-align: middle;
        font-weight: bold;
    }

    .description{
        display: inline-block;
        vertical-align: middle;
    }

    .goToAll {
        margin: 10px auto;
        display: block;
        border: solid 1px #0073bb;
        width: 96px;
    }

    /*爆款推荐*/
    .shipDetail-hotCruise {
        background-color: #fff;
        padding-bottom: 50px;
    }
</style>
